import axiosSync from "@/axiosSync";

export function usePortInfoBdComEponApi() {
  async function getBasicInfo(olt_id) {
    const response = await axiosSync.get(`/bdcom-epon?oltid=${olt_id}&url_pr=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getPonOpticalPowerData(olt_id) {
    const response = await axiosSync.get(`/bdcom-epon?oltid=${olt_id}&&type=eponopticaldiagnosis&url_pr=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getPortStatusData(olt_id) {
    const response = await axiosSync.get(`/bdcom-epon?oltid=${olt_id}&&type=intfstate&url_pr=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }

  return {    
    getBasicInfo,
    getPonOpticalPowerData,
    getPortStatusData,
  };
}
